import React, { Fragment, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { Controller } from "react-hook-form";
import Select from "react-select";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
const CreateModal = ({ toggleModal }) => {
  const { register, control, watch } = useForm({
    defaultValues: {
      tipePertemuan: {
        value: 1,
        label: "TUTORIAL",
      },
      kelompokModul: {
        value: 1,
        label: "Import Excel",
      },
    },
  });

  const tipe = watch("tipePertemuan");
  const kelompokModul = watch("kelompokModul");

  const kelompokOption = [
    { value: "A", label: "A" },
    { value: "B", label: "B" },
  ];

  const sesiOption = [
    { value: 1, label: "1" },
    { value: 2, label: "2" },
  ];
  const kasusOption = [
    { value: 1, label: "Pendahuluan" },
    { value: 2, label: "Sirkulasi Jantung" },
  ];
  const topikOption = [
    { value: 1, label: "Pendahuluan" },
    { value: 2, label: "Sirkulasi Jantung" },
  ];

  const tipeOption = [
    { value: 1, label: "TUTORIAL" },
    { value: 2, label: "PLENO" },
    { value: 3, label: "KKD" },
    { value: 4, label: "PERKULIAHAN" },
    { value: 5, label: "PRAKTIKUM" },
  ];

  const ruanganOption = [
    { value: 1, label: "501" },
    { value: 2, label: "502" },
    { value: 3, label: "503" },
  ];

  const fasilitatorOption = [
    { value: "Purnamawati Tjhin", label: "Purnamawati Tjhin" },
    { value: "Eveline Margo", label: "Eveline Margo" },
    { value: "Tjam Diana Samara", label: "Tjam Diana Samara" },
  ];

  const kelompokModulOption = [
    { value: 1, label: "Import Excel" },
    { value: 2, label: "Input Manual" },
  ];

  const mahasiswaOption = [
    { value: "1", label: "Rafi" },
    { value: "2", label: "Zami" },
  ];

  const closeModal = () => {
    toggleModal(false);
  };
  return (
    <Modal show={toggleModal} onHide={closeModal} size="xl">
      <Modal.Header closeButton>
        <Modal.Title>
          <h6>Tambah Pertemuan</h6>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row mb-3">
          <div className="col-md-4">
            <div className="form-group">
              <label className="form-label">Kelompok</label>
              <Controller
                control={control}
                name="kelompok"
                render={({ field }) => (
                  <Select
                    placeholder="-- Pilih Salah Satu --"
                    value={field.value}
                    options={kelompokOption}
                    {...field}
                  />
                )}
              />
            </div>
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-4">
            <div className="form-group">
              <label className="form-label">Tipe Pertemuan</label>
              <Controller
                control={control}
                name="tipePertemuan"
                render={({ field }) => (
                  <Select
                    placeholder="-- Pilih Salah Satu --"
                    value={field.value}
                    options={tipeOption}
                    {...field}
                  />
                )}
              />
            </div>
          </div>

          {tipe.value === 1 && (
            <Fragment>
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">Sesi</label>
                  <Controller
                    control={control}
                    name="sesi"
                    render={({ field }) => (
                      <Select
                        placeholder="-- Pilih Salah Satu --"
                        value={field.value}
                        options={sesiOption}
                        {...field}
                      />
                    )}
                  />
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">Kasus</label>
                  <Controller
                    control={control}
                    name="kasus"
                    render={({ field }) => (
                      <Select
                        placeholder="-- Pilih Salah Satu --"
                        value={field.value}
                        options={kasusOption}
                        {...field}
                      />
                    )}
                  />
                  <Link style={{ textDecoration: "none" }}>
                    + Tambah Kasus Baru
                  </Link>
                </div>
              </div>
            </Fragment>
          )}

          {tipe.value !== 1 && (
            <div className="col-md-4">
              <div className="form-group">
                <label className="form-label">Topik</label>
                <Controller
                  control={control}
                  name="topik"
                  render={({ field }) => (
                    <Select
                      placeholder="-- Pilih Salah Satu --"
                      value={field.value}
                      options={topikOption}
                      {...field}
                    />
                  )}
                />
                <Link style={{ textDecoration: "none" }}>
                  + Tambah Topik Baru
                </Link>
              </div>
            </div>
          )}
        </div>

        <div className="row mb-3">
          <div className="col-md-4">
            <div className="form-group">
              <label className="form-label">Tanggal</label>
              <input
                type="date"
                {...register("tanggal")}
                className="form-control"
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label className="form-label">Waktu Mulai</label>
              <input
                type="time"
                {...register("waktuMulai")}
                className="form-control"
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label className="form-label">Waktu Selesai</label>
              <input
                type="time"
                {...register("waktuSelesai")}
                className="form-control"
              />
            </div>
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-4">
            <div className="form-group">
              <label className="form-label">Ruangan</label>
              <Controller
                control={control}
                name="ruangan"
                render={({ field }) => (
                  <Select
                    placeholder="-- Pilih Salah Satu --"
                    value={field.value}
                    options={ruanganOption}
                    {...field}
                  />
                )}
              />
            </div>
          </div>
        </div>

        {(tipe.value === 1 || tipe.value === 3) && (
          <Fragment>
            <div className="row mb-3">
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">Kelompok Modul</label>
                  <Controller
                    control={control}
                    name="kelompokModul"
                    render={({ field }) => (
                      <Select
                        placeholder="-- Pilih Salah Satu --"
                        value={field.value}
                        options={kelompokModulOption}
                        {...field}
                      />
                    )}
                  />
                  <Link style={{ textDecoration: "none" }}>
                    <i className="fas fa-file-excel"></i> Unduh Template
                  </Link>
                </div>
              </div>
            </div>
          </Fragment>
        )}

        {tipe.value !== 1 && tipe.value !== 3 && (
          <div className="row mb-3">
            <div className="col-md-4">
              <div className="form-group">
                <label className="form-label">Pengajar</label>
                <Controller
                  control={control}
                  name="pengajar"
                  render={({ field }) => (
                    <Select
                      placeholder="-- Pilih Salah Satu --"
                      value={field.value}
                      options={fasilitatorOption}
                      {...field}
                    />
                  )}
                />
              </div>
            </div>
          </div>
        )}

        {tipe.value === 1 && kelompokModul.value === 1 && (
          <div className="row mb-3">
            <div className="col-md-4">
              <div className="form-group">
                <label className="form-label">Unggah File Kelompok Tutor</label>
                <input type="file" className="form-control" />
              </div>
            </div>
          </div>
        )}

        {tipe.value === 1 && kelompokModul.value === 2 && (
          <div className="row mb-3">
            <div className="col-md-4">
              <div className="form-group">
                <label className="form-label">Fasilitator</label>
                <Controller
                  control={control}
                  name="fasilitator"
                  render={({ field }) => (
                    <Select
                      placeholder="-- Pilih Salah Satu --"
                      value={field.value}
                      options={fasilitatorOption}
                      {...field}
                    />
                  )}
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label className="form-label">Mahasiswa</label>
                <Controller
                  control={control}
                  name="mahasiswa"
                  render={({ field }) => (
                    <Select
                      placeholder="-- Pilih Salah Satu --"
                      value={field.value}
                      isMulti
                      options={mahasiswaOption}
                      {...field}
                    />
                  )}
                />
              </div>
            </div>
          </div>
        )}

        {tipe.value === 3 && kelompokModul.value === 1 && (
          <div className="row mb-3">
            <div className="col-md-4">
              <div className="form-group">
                <label className="form-label">Unggah File Kelompok Tutor</label>
                <input type="file" className="form-control" />
              </div>
            </div>
          </div>
        )}

        {tipe.value === 3 && kelompokModul.value === 2 && (
          <div className="row mb-3">
            <div className="col-md-4">
              <div className="form-group">
                <label className="form-label">Pengajar</label>
                <Controller
                  control={control}
                  name="pengajar"
                  render={({ field }) => (
                    <Select
                      placeholder="-- Pilih Salah Satu --"
                      value={field.value}
                      options={fasilitatorOption}
                      {...field}
                    />
                  )}
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label className="form-label">Mahasiswa</label>
                <Controller
                  control={control}
                  name="mahasiswa"
                  render={({ field }) => (
                    <Select
                      placeholder="-- Pilih Salah Satu --"
                      value={field.value}
                      isMulti
                      options={mahasiswaOption}
                      {...field}
                    />
                  )}
                />
              </div>
            </div>
          </div>
        )}

        <button className="btn w-100 btn-success" onClick={closeModal}>
          Tambah
        </button>
      </Modal.Body>
    </Modal>
  );
};

export default CreateModal;
